import { render, staticRenderFns } from "./Birthdate.vue?vue&type=template&id=5b24bd9c"
import script from "./Birthdate.vue?vue&type=script&lang=js"
export * from "./Birthdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports